<simple-notifications></simple-notifications>
<router-outlet></router-outlet>
